import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=70424820&scoped=true"
import script from "./detailPage.vue?vue&type=script&lang=js"
export * from "./detailPage.vue?vue&type=script&lang=js"
import style0 from "./detailPage.vue?vue&type=style&index=0&id=70424820&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70424820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70424820')) {
      api.createRecord('70424820', component.options)
    } else {
      api.reload('70424820', component.options)
    }
    module.hot.accept("./detailPage.vue?vue&type=template&id=70424820&scoped=true", function () {
      api.rerender('70424820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/feedback/feedbacklist/table/components/detailPage.vue"
export default component.exports